module.exports = __webpack_public_path__ + "1_0_57/img/Kalon.dc6ffb2d.jpg";